import TicketCuticleDot from '@/components/manage/TicketCuticleDot';
import TicketCuticleLine from '@/components/manage/TicketCuticleLine';
import { cn } from '@/utils/cn';

interface TicketCuticleProps {
  isVertical?: boolean;
  className?: {
    dot?: string;
    line?: string;
  };
}

const TicketCuticle = ({
  isVertical = true,
  className,
}: TicketCuticleProps) => {
  return (
    <div
      className={cn(
        'flex items-center',
        isVertical ? 'h-full w-6 flex-col' : 'h-6 w-full flex-row'
      )}
    >
      <TicketCuticleDot
        isVertical={isVertical}
        position="start"
        className={cn(isVertical ? 'mb-0.5' : 'mr-0.5', className?.dot)}
      />
      <TicketCuticleLine isVertical={isVertical} className={className?.line} />
      <TicketCuticleDot
        isVertical={isVertical}
        position="end"
        className={cn(isVertical ? 'mt-0.5' : 'ml-0.5', className?.dot)}
      />
    </div>
  );
};

export default TicketCuticle;
